import { LockMixin } from "apps-module/app/shared-library/mixins/lock.mixin";
import { EmptyInstance } from "core-library/mixins/empty-instance";
import { EventEmitterMixin } from "widgets-module/mixins/event-emitter.mixin";
import { cookieService } from "widgets-module/services/cookie.service";

import { AccessibilityModel } from "./models/accessibility.model";

export class AccessibilityComponent extends EventEmitterMixin(LockMixin(EmptyInstance)) {
    private readonly COOKIE_NAME = "assist_accessibilityComponent";

    private _currentContext: JQuery = $();

    private _moduleOptions: AccessibilityModel = {
        fontSizes: {
            normal: "16px",
            large: "18px",
            largest: "20px"
        },
        cookie: null,
        styles: {
            normal: "normal",
            contrast: "contrast"
        },
        currentStyle: null,
        currentFontSize: null
    };

    private saveCookie(): void {
        const cookieValue = `${this._moduleOptions.currentFontSize}|${this._moduleOptions.currentStyle}`;
        cookieService.set(this.COOKIE_NAME, cookieValue, { expires: 100, path: "/" });
    }

    private setFontSize(size: string | null): void {
        if (!size) {
            return;
        }

        this._moduleOptions.currentFontSize = size;

        $("html").css("font-size", this._moduleOptions.fontSizes[size]);

        this.saveCookie();
    }

    private setStyleSheet(name: string | null): void {
        if (!name) {
            return;
        }

        this._moduleOptions.currentStyle = name;

        $(".js-contrast-style").each((i, element) => {
            $(element).prop("disabled", true);

            if (this._moduleOptions.styles.contrast === name) {
                $(element).prop("disabled", false);
            }
        });

        this.saveCookie();
    }

    private setModuleOptions(): void {
        try {
            const myCookie = cookieService.get(this.COOKIE_NAME);

            if (myCookie) {
                this._moduleOptions.cookie = myCookie.split("|");
                this._moduleOptions.currentFontSize = this._moduleOptions.cookie[0];
                this._moduleOptions.currentStyle = this._moduleOptions.cookie[1];
            } else {
                this._moduleOptions.currentFontSize = this._moduleOptions.fontSizes.normal;
                this._moduleOptions.currentStyle = this._moduleOptions.styles.normal;
            }
        } catch (e) {
            // Error handling
            console.log(e);
        }
    }

    private bindEvents(): void {
        // font size events
        $(".js-fontsize-normal", this._currentContext).on("click", (e) => {
            e.preventDefault();
            this.setFontSize("normal");
        });

        $(".js-fontsize-medium", this._currentContext).on("click", (e) => {
            e.preventDefault();
            this.setFontSize("large");
        });

        $(".js-fontsize-large", this._currentContext).on("click", (e) => {
            e.preventDefault();
            this.setFontSize("largest");
        });

        // style events
        $(".js-switch-css-normal", this._currentContext).on("click", (e) => {
            e.preventDefault();
            this.setStyleSheet(this._moduleOptions.styles.normal);
        });

        $(".js-switch-css-contrast", this._currentContext).on("click", (e) => {
            e.preventDefault();
            this.setStyleSheet(this._moduleOptions.styles.contrast);
        });
    }

    public init(context: JQuery, options: object): void {
        this._currentContext = context || this._currentContext;

        $.extend(this._moduleOptions, options);

        this.setModuleOptions();
        this.bindEvents();

        this.setFontSize(this._moduleOptions.currentFontSize);
        this.setStyleSheet(this._moduleOptions.currentStyle);
    }
}
